import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62 62"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M39.1 39.15H22.9m11.2 3.7H22.9m16.2-7.5H22.9M18.6 12.85h24.8c1.1 0 2 .9 2 2v32.2c0 1.1-.9 2-2 2H18.6c-1.1 0-2-.9-2-2v-32.2c0-1.1.9-2 2-2z" />
      <path strokeWidth="1.5" d="M34.2 21.25c-.3-1.1-1.4-1.8-2.5-1.7-.6-.1-1.2.1-1.7.5s-.8 1-.8 1.6c0 1.2 1.1 1.7 2.6 2.3 1.5.5 2.4 1 2.5 2.2 0 2.3-2.4 2.3-2.7 2.3-1.3.1-2.4-.8-2.7-2.1m2.8 4.5v-2.1m0-9.3v-2" />
    </svg>
  </span>
);

export default icon;
